import React from 'react'
import { Mutation } from "react-apollo";
import { DELETE,GET } from "../../../queries/user";
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

function filteredData(s, l, ls){
  s.data.forEach(d => {
    const id = ls[d.dataIndex].id;
      l = l.filter(e => e.id !== id)
    })
  return l;
}

class Delete extends React.Component {
  render(){
    const { selectedRows, users } = this.props;
    return (
      <Mutation
        mutation={DELETE}
        update={(store, { data: { deleteUser } }) => {
          const { users } = store.readQuery({ query: GET });
          store.writeQuery({
            query: GET,
            data: { users: filteredData(selectedRows, users, users) }
          });
        }}
        >
        {deleteUser => (
          <div>
            <IconButton aria-label="delete" onClick = {
              e => {
                e.preventDefault();
                selectedRows.data.forEach(d => {
                  const id = users[d.dataIndex].id;
                  deleteUser({ variables: {id: id }})  
                });
              }
            }>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
      </Mutation>
    );
  }
};

export default Delete;